import Vue from 'vue'
import App from './App.vue'
import 'promise-polyfill/src/polyfill';
import BootstrapVue from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSweetalert2 from 'vue-sweetalert2';
import axios from 'axios';

import VueAxios from 'vue-axios'
Vue.prototype.$axios = axios
Vue.use(VueAxios, axios)



import datePicker from 'vue-bootstrap-datetimepicker';




Vue.use(BootstrapVue)
Vue.use(require('vue-moment'));
Vue.use(VueSweetalert2);
Vue.use(datePicker)
Vue.use(VueAxios, axios)

library.add(fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('date-picker', datePicker);

import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
